import React, { useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import "./hero.css";
import Particles from "./utils/Particles";
const HeroSection = () => {
  useEffect(() => {
    const hero = document.querySelector(".hero-content");
    hero.classList.add("show");
  }, []);

  return (
    <section className="hero-section">
      {/* 🔹 Particles Background */}
      <div className="particles-bg">
        <Particles
          particleColors={["#ffffffff"]}
          particleCount={1500}
          particleSpread={10}
          speed={0.2}
          particleBaseSize={80}
          moveParticlesOnHover={true}
          alphaParticles={true}
          disableRotation={false}
        />
      </div>

      {/* 🔹 Dark Overlay */}
      <div className="hero-overlay"></div>

      <Container>
        <div className="hero-content">
          <h1
            style={{
              color: "#e6e4ddff",
              fontFamily: "sans-serif",
              fontWeight: "800",
            }}
          >
            International Council of Sanatan Advocacy & Justice
          </h1>

          <p
            style={{
              // color: "#c72800ff",
              color: "#e6e4ddff",

              fontWeight: "700",
              fontSize: "26px",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            Strengthening the legal ecosystem through ethical advocacy,
            research, education, and community engagement.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;
